import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FeatureFlagsService } from '~modules/administration/feature-flags.service';
import { Router } from '@angular/router';
import { Subscription, distinctUntilChanged } from 'rxjs';
import { SafeUrlModule } from 'src/app/utils/pipes/safe-url.module';

@Component({
  selector: 'app-scheduling',
  templateUrl: './scheduling.component.html',
  standalone: true,
  imports: [MatIconModule, SafeUrlModule],
})
export class SchedulingComponent implements OnInit, OnDestroy {
  schedulingUrl!: string;
  private subscription?: Subscription;

  constructor(
    private readonly titleService: Title,
    private readonly flags: FeatureFlagsService,
    private readonly router: Router
  ) {
    this.titleService.setTitle('Prendre rendez-vous');
  }

  ngOnInit(): void {
    this.schedulingUrl = environment.schedulingUrl;

    // subscription to redirect if the feature is disabled while on the page
    this.subscription = this.flags
      .isEnabled('ENABLE_SCHEDULING')
      .pipe(distinctUntilChanged())
      .subscribe((enabled) => {
        if (!enabled) {
          this.router.navigate(['/welcome']);
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
